'use client'

import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import styles from './Who.module.css';

export default function Who({ismobile}) {
    
    const sectionRef = useRef(null);
    const mainTextRef = useRef(null);
    const leftTextRef = useRef(null);
    const rightTextRef = useRef(null);
    useEffect(() => {
        const ctx = gsap.context(() => {
          const mm = gsap.matchMedia();

  // 🧠 define your breakpoints
  mm.add("(min-width: 768px)", () => {
    // ✅ create context inside the matchMedia callback

        gsap.registerPlugin(ScrollTrigger);
        
            // Initial setup - hide moving texts and position them
            gsap.set(leftTextRef.current, {
                x: "-100vw", // Start from far left
                y: "-20vh",  // Slightly above center
                zIndex: -1,
            });

            gsap.set(rightTextRef.current, {
                x: "100vw",  // Start from far right
                y: "20vh",   // Slightly below center
                zIndex: -1,
            });

            gsap.set(mainTextRef.current, {
                x: "0",
                y: "0",  // Slightly above center
            });

           

            // Create the animation timeline
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top top",
                    end: "+=100%",
                    pin: sectionRef.current,
                    anticipatePin: 1, // Smooth pin anticipation
                    scrub: 0.3,
                 
                }
            });

            tl
                // Phase 2: Left text slides in from left
                .to(leftTextRef.current, {
                    x: 0,
                    duration: 0.4,
                    ease: "power3.out"
                }, "a")
                // Phase 3: Right text slides in from right (slightly delayed)
                .to(rightTextRef.current, {
                    x: 0,
                    duration: 0.4,
                    ease: "power3.out"
                }, "a")
               

                .to(leftTextRef.current, {
                    y: "0",
                    duration: 0.3,
                    ease: "power2.inOut"
                }, "z")
                .to(rightTextRef.current, {
                    y: "0",
                    duration: 0.3,
                    ease: "power2.inOut"
                }, "z").to(leftTextRef.current, {
                   autoAlpha:0,
                    duration: 0.3,
                    ease: "power2.inOut"
                }, "z")
                .to(rightTextRef.current, {
                   autoAlpha:0,
                    duration: 0.3,
                    ease: "power2.inOut"
                }, "z").to(mainTextRef.current,{scale:.3,y:"-80px"}).to(".longDesc",{autoAlpha:1})

        });
        return () => mm.revert()

    })

        return () => ctx.revert();
    }, []);

    return (
        <section ref={sectionRef} className={styles.whoAreWe}>
            {/* Main text - always visible, on top initially */}
            <div ref={mainTextRef} className={styles.textContainer}>
                <h1 className={styles.whoAreWeText}>
                    WHO ARE WE?
                </h1>
            </div>

            {/* Left sliding text */}
            <div ref={leftTextRef} className={styles.leftText}>
                <h1 className={styles.whoAreWeText}>
                    WHO ARE WE?
                </h1>
            </div>

            {/* Right sliding text */}
            <div ref={rightTextRef} className={styles.rightText}>
                <h1 className={styles.whoAreWeText}>
                    WHO ARE WE?
                </h1>
            </div>
            
            <p className={`longDesc ${styles.longDesc}`}>
                Logvplus – Compléments alimentaires pour booster votre vitalité, longévité et votre santé générale.
                Découvrez nos formules certifiées pour renforcer votre bien-être au quotidien.
            </p>
        </section> 
    );
}
